<template>
  <div name="modal">
    <b-spinner v-if="loading"/>
    <div class="modal-mask modal-import">
      <div class="modal-wrapper">
        <form @submit.prevent>
          <div class="modal-container child">
            <div class="modal-header"><h3>Import</h3></div>
            <div class="modal-body">
              <div class="form-group row">
                <div class="col-xs-18">
                  <div id="file-container" style="">
                    <a
                      v-b-tooltip.hover 
                      id="import-btn"
                      title="Accepted extensions: .csv and .js">
                      <label 
                        for="fileinput">Select file</label>
                      <input
                        id="fileinput"
                        ref="file"
                        type="file"
                        class="inputfile"
                        @change="importFile">
                    </a>
                    <div id="file-name">{{ fileName }}</div>
                  </div>
                  <div style="float:left;margin-left: 20px;width: 50%">
                    <label for="lang-select"><span v-if="isLangRequired" style="color:red">*</span>Language: </label>
                    <select
                      id="lang-select"
                      v-model="selectedLang"
                      :required="isLangRequired"
                      name="label-filter-langs"
                      class="form-control form-control-sm">
                      <option value selected>Select language</option>
                      <option
                        v-for="(eachLang, langIndex) in allLanguages"
                        :key="langIndex + 'option'"
                        :value="eachLang.id">{{ eachLang.name }}</option>
                    </select>
                  </div>
                  <div>
                    <label for="group-select"><span style="color: red">*</span>Group: </label>
                    <select
                      id="group-select"
                      v-model="filter.group"
                      name="label-filter-group"
                      class="form-control form-control-sm">
                      <option value selected>Select group</option>
                      <option
                        v-for="(eachGroup, groupIndex) in groups"
                        :key="groupIndex + 'option'"
                        :value="eachGroup.id">{{ eachGroup.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                :disabled="!fileName || (isLangRequired && !selectedLang) || !filter.group"
                type="button"
                style="float:left"
                class="btn btn-sm btn-primary m-1"
                @click="saveImport()">
                Import
              </button>
              <button
                type="button"
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, } from 'vuex';
import csvToJSON from '@/services/utils';
import {
    db,
    labelsCollection,
    translationsCollection,
} from '@/services/firebaseConfig';

export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['labels', 'languages', 'groups',],
    data() {
        return {
            selectedLang: '',
            counter: 0,
            isLangRequired: false,
            file: null,
            fileName: null,
            fileType: null,
            uploadedFile: [],
            filter: {
                group: '',
                label: null,
            },
        };
    },
    computed: {
        ...mapGetters(['importedLabels', 'allLanguages', 'loading',]),
    },
    methods: {
        ...mapMutations(['setImportedLabels', 'startLoading', 'stopLoading',]),
        importFile() {
            this.file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            this.fileName = this.file.name;
            this.fileType = this.file.type;

            let reader = new FileReader();

            reader.onload = (e) => {
                if (this.fileType === 'text/csv') {
                    this.isLangRequired = true;

                    this.setImportedLabels(csvToJSON(e.target.result));
                } else if (this.fileType === 'text/javascript') {
                    this.isLangRequired = false;

                    eval(
                        e.target.result +
                            '; sessionStorage.setItem("trans" , JSON.stringify(jsonData));'
                    );
                }
            };

            reader.readAsText(this.file);
        },
        saveImport() {
            this.startLoading();

            if (this.fileType === 'text/csv') {
                this.importedLabels.forEach((el) => {
                    if (el.Label && el) {
                        labelsCollection
                            .add({
                                name: el.Label,
                                group: db.doc('groups/' + this.filter.group),
                            })
                            .then((docRef) => {
                                if (el && el.Translation) {
                                    translationsCollection.add({
                                        value: el.Translation,
                                        label: db.doc('labels/' + docRef.id),
                                        language: db.doc(
                                            'languages/' + this.selectedLang
                                        ),
                                    });
                                }
                            });
                    }
                });
                this.stopLoading();
            } else if (this.fileType === 'text/javascript') {
                this.saveImportJsFile();
            }
            this.$emit('close');
            this.stopLoading();

            // TO DO: refresh the data!
        },
        saveImportJsFile() {
            let jsonData = JSON.parse(sessionStorage.getItem('trans'));
            let langNotFound = [];
            let allLangsArr = [];

            for (let objTrans in jsonData) {
                this.allLanguages.forEach((lang) => {
                    allLangsArr.push(lang.name);

                    if (objTrans == lang.name) {
                        for (let label in jsonData[objTrans]) {
                            labelsCollection
                                .add({
                                    name: label,
                                    group: db.doc(
                                        'groups/' + this.filter.group
                                    ),
                                })
                                .then((docRef) => {
                                    translationsCollection.add({
                                        value: jsonData[objTrans][label],
                                        label: db.doc('labels/' + docRef.id),
                                        language: db.doc(
                                            'languages/' + objTrans
                                        ),
                                    });
                                });
                        }
                    } else {
                        langNotFound.push(objTrans);
                    }
                });
                this.counter++;
            }

            langNotFound.forEach((item) => {
                if (allLangsArr.indexOf(item) === -1) {
                    console.log(// eslint-disable-line
                        `Could not find language ${item}. Please add it on the Languages section!`
                    );
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/ModalImport/ModalImport.vue